import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kat-sticker-pack',
  templateUrl: './kat-sticker-pack.component.html',
  styleUrls: ['./kat-sticker-pack.component.scss']
})
export class KatStickerPackComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
